module.exports = __webpack_public_path__ + "img/9788957594995.0c10f857.jpg";